import { useCallback, useRef } from 'react';

import { BindingCreator } from '@dreryk/react-common';

import { MedicalProfileTabFormBean } from './tab/MedicalProfileTab.types';

export const useStableRegister = (
   register: BindingCreator<MedicalProfileTabFormBean>
): BindingCreator<MedicalProfileTabFormBean> => {
   const registerRef = useRef(register);
   registerRef.current = register;

   return useCallback<BindingCreator<MedicalProfileTabFormBean>>(
      (name, validationRules) => registerRef.current(name, validationRules),
      []
   );
};
